<div class="banner-area banner-area-three">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="banner-text">
          <!-- <h1>3 clicks away from <span>Quality</span> Service</h1> -->
          <h1>Digital <span>Solutions</span> for every Business</h1>
          <p>
            Tailored to your unique needs for seamless operations and to
            maximize potential
          </p>

          <div class="banner-form-area">
            <form [formGroup]="homeform" (ngSubmit)="performSearch()">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label><i class="icofont-search-1"></i></label>
                    <!-- <p>What Do You Need</p> -->
                    <input
                      type="text"
                      class="form-control"
                      formControlName="category"
                      placeholder="What do you need"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label><i class="icofont-location-pin"></i></label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="city"
                      placeholder="Where do you need it"
                    />
                  </div>
                </div>
              </div>

              <button type="submit" class="btn banner-form-btn">
                Let's Talk
              </button>
            </form>
          </div>
        </div>

        <div class="banner-img">
          <img src="assets/img/home/home_.png" alt="Banner" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="create-area">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-8">
        <div class="create-item">
          <!-- <h2>
            Create your service profile and get discovered by thousands of
            clients anywhere you are!
          </h2> -->
          <h2>Software solutions for all businesses</h2>
        </div>
      </div>

      <div *ngIf="!currentUser" class="col-lg-4">
        <div class="create-item">
          <div class="create-btn">
            <!-- <a (click)="somefunction(currentUser)">Create Service Profile</a> -->
            <a routerLink="/register_as">Explore</a>
          </div>
        </div>
      </div>
      <div *ngIf="currentUser" class="col-lg-4">
        <div class="create-item">
          <div class="create-btn">
            <a (click)="somefunction(currentUser)">Create Service Profile</a>
            <!-- <a routerLink="/register_as" (click)="somefunction()">Create Service Profile</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="category-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>Top Service Categories</h2>
    </div>

    <div class="row">
      <div class="col-sm-3 col-lg-3 category-border">
        <div class="category-item">
          <i class="flaticon-settings"></i>
          <a routerLink="/">Technicians & Mechanics</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border">
        <div class="category-item category-two">
          <i class="flaticon-enterprise"></i>
          <a routerLink="/">Electronics</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border">
        <div class="category-item category-three">
          <i class="flaticon-house"></i>
          <a routerLink="/">Real Estate Business</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border">
        <div class="category-item category-four">
          <i class="flaticon-customer-service"></i>
          <a routerLink="/">Consultancy </a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border-three">
        <div class="category-item category-five">
          <i class="flaticon-employee"></i>
          <a routerLink="/">General Artisans</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border-two">
        <div class="category-item category-six">
          <i
            class="flaticon-businessman-paper-of-the-application-for-a-job"
          ></i>
          <a routerLink="/">Events Planning</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border-two">
        <div class="category-item category-seven">
          <i class="flaticon-neural"></i>
          <a routerLink="/">IT & Networing Sevices</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3 category-border-two">
        <div class="category-item category-eight">
          <i class="flaticon-dish"></i>
          <a routerLink="/">Catering Services</a>
        </div>
      </div>

      <div
        class="col-sm-3 offset-sm-3 offset-lg-0 col-lg-3 category-border-two"
      >
        <div class="category-item category-nine">
          <i class="icofont-fire-burn"></i>
          <a routerLink="/">Defence & Medics</a>
        </div>
      </div>

      <div class="col-sm-3 col-lg-3">
        <div class="category-item category-ten">
          <i class="flaticon-truck"></i>
          <a routerLink="/">Logistic Services</a>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="portal-area pb-70">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="portal-item">
          <div class="row">
            <div class="col-lg-7">
              <img src="assets/img/home/trusted_2c.jpg" alt="Portal" />
            </div>

            <div class="col-lg-5">
              <!-- <img src="assets/img/home/trusted_2.jpg" alt="Portal"> -->
            </div>
          </div>

          <div class="portal-trusted">
            <span>100% Trusted</span>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="portal-item portal-right">
          <h2>Trusted & Popular Service Portal</h2>
          <p>
            With the right keywords: our A.I search algorithm is guaranteed to
            connect you with any service
          </p>
          <div class="common-btn">
            <a
              *ngIf="currentUser"
              (click)="somefunction(currentUser)"
              class="login-btn"
              >Register One <i class="icofont-swoosh-right"></i
            ></a>
            <a *ngIf="!currentUser" class="login-btn" routerLink="/register_as"
              >Register One <i class="icofont-swoosh-right"></i
            ></a>
            <a class="sign-up-btn" routerLink="/search"
              >Search for one<i class="icofont-swoosh-right"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="account-area account-area-two">
  <div class="container">
    <div class="row account-wrap">
      <div class="col-sm-6 col-lg-4">
        <div class="account-item">
          <i class="flaticon-approved"></i>
          <span>Register Your Service</span>
        </div>
      </div>

      <div class="col-sm-6 col-lg-4">
        <div class="account-item">
          <i class="flaticon-layers"></i>
          <span>Service Databank</span>
        </div>
      </div>

      <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
        <div class="account-item account-last">
          <i class="flaticon-job-search"></i>
          <span>Get Discovered by Clients</span>
        </div>
      </div>
    </div>

    <div class="banner-btn">
      <a *ngIf="currentUser" (click)="somefunction(currentUser)"
        >Create Your Profile</a
      >
      <a *ngIf="!currentUser" routerLink="/register_as">Create Your Profile</a>
      <!-- <a routerLink="/submit-resume">Upload Your CV</a> -->
    </div>
  </div>
</div>

<div class="counter-area pt-50 pb-30">
  <div class="container">
    <div class="row">
      <div class="col-6 col-sm-3 col-lg-3">
        <div class="counter-item">
          <i class="flaticon-employee"></i>
          <h3>
            <span class="counter">{{ serviceTotal }}</span
            >+
          </h3>
          <p>Registered Services</p>
        </div>
      </div>

      <div class="col-6 col-sm-3 col-lg-3">
        <div class="counter-item">
          <i class="flaticon-curriculum"></i>
          <h3><span class="counter">0</span>+</h3>
          <p>Registered Clients</p>
        </div>
      </div>

      <div class="col-6 col-sm-3 col-lg-3">
        <div class="counter-item">
          <i class="flaticon-enterprise"></i>
          <h3><span class="counter">0</span>+</h3>
          <p>Relaible Companies</p>
        </div>
      </div>

      <div class="col-6 col-sm-3 col-lg-3">
        <div class="counter-item">
          <i
            class="flaticon-businessman-paper-of-the-application-for-a-job"
          ></i>
          <h3><span class="counter"></span>+</h3>
          <p>Services Requests</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="popular-area pt-100 pb-70">
  <div class="container">
      <div class="row align-items-center">
          <div class="col-lg-6">
              <div class="popular-item">
                  <div class="row align-items-center">
                      <div class="col-lg-7">
                          <img src="assets/img/home/popular_1.jpg" alt="Popular">
                      </div>

                      <div class="col-lg-5">
                          <div class="practice-inner">
                              <img src="assets/img/home/popular_2.jpg" alt="Popular">
                              <img src="assets/img/home/popular_3.jpg" alt="Popular">
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="col-lg-6">
              <div class="popular-item popular-right">
                  <div class="section-title text-start">
                      <h2>Why We are Most Popular</h2>
                  </div>
                  <p>You don't need to know a guy who knows a guy, all you need is us. With us, you are 3 clicks away from quality service...</p>
                  <p> With us, you are 3 clicks away from quality service...</p>

                  <div class="row popular-wrap">
                      <div class="col-sm-6 col-lg-6">
                          <ul>
                              <li><i class="flaticon-approved"></i> Quality Service</li>
                              <li><i class="flaticon-no-money"></i> Completely Free</li>
                          </ul>
                      </div>

                      <div class="col-sm-6 col-lg-6">
                          <ul>
                              <li><i class="flaticon-enterprise"></i> Top Companies</li>
                              <li><i class="flaticon-employee"></i> Global Awareness</li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->

<section class="companies-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>Top Services</h2>
    </div>

    <div class="companies-slider owl-theme owl-carousel">
      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>

      <div class="companies-item">
        <img src="assets/img/home/coming_soon.jpg" alt="Companies" />
        <h3><a routerLink="/">Coming Soon</a></h3>
        <!-- <p><i class="icofont-location-pin"></i> Quadra, Street, Canada</p> -->
        <!-- <a class="companies-btn" routerLink="/work_in_progress">Hiring</a> -->
      </div>
    </div>
  </div>
</section>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#40a834"
  type="line-scale"
  [fullScreen]="true"
>
  <p style="color: rgb(250, 242, 242)">Loading...</p>
</ngx-spinner>
